const STORAGE_KEY = 'flowboard_recent_issues';
const MAX_RECENT = 10;

export type RecentIssue = {
  id: string;
  title: string;
  projectId: string;
};

export function getRecentIssues(): RecentIssue[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as RecentIssue[];
    return Array.isArray(parsed) ? parsed.slice(0, MAX_RECENT) : [];
  } catch {
    return [];
  }
}

export function addRecentIssue(issue: {
  _id: string;
  title: string;
  project: string;
}): void {
  try {
    const list = getRecentIssues().filter((r) => r.id !== issue._id);
    list.unshift({
      id: issue._id,
      title: issue.title,
      projectId: issue.project,
    });
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify(list.slice(0, MAX_RECENT))
    );
  } catch {
    // ignore
  }
  window.dispatchEvent(new CustomEvent('flowboard-recent-issues-changed'));
}
